import {Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {DataService} from '../../../../Services/data.service';
import { AppConfigService } from '../../../../Services/app-config.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ResponseModel } from '../../../../DataModels/response-model';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-reporting-field-type-list',
  templateUrl: './reporting-field-type-list.component.html',
  styleUrls: ['./reporting-field-type-list.component.css'],
  standalone: false
})
export class ReportingFieldTypeListComponent extends ListPageBase implements OnInit {
  ReportingFieldTypeCount = 0;
  isLoaded = false;

  constructor(
    private titleService: Title,
    private tableDataService: DataService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }


  vm: any = [];

  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle($localize`:Reporting Field Type List@@reportingFieldTypeList:Reporting Field Type List`);
    this.vm.list = [];
    this.getData();
  }

  getData() {
    let paramString = '?pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('reporting_field_type', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.ReportingFieldTypeCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
      }
    );
  }

  onNavigate(aID: string) {
    this.router.navigate(['admin/reporting-field-type-form', { id: aID }]).then();
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '?pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('reporting_field_type', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.ReportingFieldTypeCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
      }
    );
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
